import CoinIcon from "../../../assets/icons/CoinIcon";
import EventActionIcon, {
  resolveEventActionIconType,
} from "../../../assets/icons/EventActionIcon";
import React from "react";
import {
  buildTransactionIconLabel,
  buildTransactionId,
  buildTransactionMeta,
} from "./transactionUtils";

type TransactionListProps = {
  transactions: any[];
  emptyLabel?: string;
  className?: string;
  showDateInMiddle?: boolean;
};

const TransactionList = ({
  transactions,
  emptyLabel,
  className,
  showDateInMiddle = true,
}: TransactionListProps) => {
  const containerClassName = ["coin-wallet-transactions", className]
    .filter(Boolean)
    .join(" ");

  if (!transactions.length) {
    return emptyLabel ? (
      <div className={containerClassName}>
        <div className="coin-wallet-empty">{emptyLabel}</div>
      </div>
    ) : (
      <div className={containerClassName} />
    );
  }

  return (
    <div className={containerClassName}>
      {transactions.map((transaction) => {
        const meta = buildTransactionMeta(transaction);
        const amountClass = meta.isCredit
          ? "coin-wallet-amount--credit"
          : "coin-wallet-amount--debit";
        const amountPrefix = meta.isCredit ? "+" : "-";
        const iconLabel = buildTransactionIconLabel(meta.title);
        const eventType = String(
          transaction?.eventType || transaction?.event || "",
        )
          .trim()
          .toUpperCase();
        const eventIconType = resolveEventActionIconType(eventType);
        const transactionId = buildTransactionId(transaction, meta);

        return (
          <div key={transactionId} className="coin-wallet-transaction">
            <div className="coin-wallet-transaction__left">
              <div className="coin-wallet-transaction__icon">
                {eventIconType ? (
                  <EventActionIcon
                    type={eventIconType}
                    className="coin-wallet-transaction__icon-svg"
                  />
                ) : (
                  iconLabel || "C"
                )}
              </div>
              <div>
                <div className="coin-wallet-transaction__title">
                  {meta.title}
                </div>
                {meta.subtitle && (
                  <div className="coin-wallet-transaction__subtitle">
                    {meta.subtitle}
                  </div>
                )}
              </div>
            </div>

            {showDateInMiddle && (
              <div className="coin-wallet-transaction__middle">
                <div className="coin-wallet-transaction__date">
                  {meta.date}
                </div>
              </div>
            )}

            <div className="coin-wallet-transaction__right">
              {!showDateInMiddle && (
                <div className="coin-wallet-transaction__date">
                  {meta.date}
                </div>
              )}
              <div className={`coin-wallet-amount ${amountClass}`}>
                {amountPrefix}
                {meta.amount}
                <CoinIcon
                  className="gi-coin-icon gi-coin-small"
                  aria-hidden="true"
                />
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default TransactionList;
